import React from 'react';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import image from './Pages/img/ppk.jpeg'
import image2 from './Pages/img/pph.jpg'

import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Routes from './Routes';
function App() {
  return (
    <div style={{ backgroundImage:`url(${image})`,  backgroundRepeat: 'no-repeat',  backgroundSize: 'cover' }}>
    <Router >
      <Routes />
    </Router>
</div>
  

  );
}
export default App;
